var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSplash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 249,
    height: 226,
    viewBox: "0 0 249 226",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.1 66.3395C83.2482 47.1857 105.724 -3.57203 147.359 0.790996C192.043 5.47358 230.041 44.4652 244.641 87.1451C258.162 126.669 229.929 164.609 216.939 204.192C203.786 244.272 204.164 292.444 169.463 316.224C131.74 342.074 75.2718 353.536 37.8408 326.924C1.99172 301.437 28.4393 242.976 10.1098 202.929C-7.00186 165.543 -72.4694 148.408 -62.0189 108.747C-51.7321 69.7064 10.3317 84.7817 46.1 66.3395Z",
    fill: "#EF136F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplash);
export default __webpack_public_path__ + "static/media/splash.3bdfc4335498d6e5394680e0dd7aa292.svg";
export { ForwardRef as ReactComponent };